export default __webpack_public_path__ + "static/media/printerneeds.6796971a.png";